export default "__VITE_ASSET__ntffC41V__"